document.querySelectorAll('form#create_customer .accordion').forEach(e => {
	// var reqFields = e.querySelectorAll('[required]');
	var reqFields = e.querySelectorAll('input[type="text"], input[type="password"], input[type="email"], select');
	const checkBoxes = e.querySelectorAll('[type="checkbox"]');

	
	if (checkBoxes.length > 0) {
			checkBoxes.forEach(c => {
					c.addEventListener('change', function () {
							if (c.value == 'Other' && c.checked) {
									document.getElementById('RegisterForm-Other').setAttribute('required','')
									// reqFields = e.querySelectorAll('[required]');
									reqFields = e.querySelectorAll('input[type="text"], input[type="password"], input[type="email"], select');
							}
							checkReqs(e, reqFields, checkBoxes);
							onChange()
					});
			});
	}
	
	onChange()

	function onChange() {
			reqFields.forEach(input => {
					if (input.type != 'checkbox' && (input.tagName == 'INPUT' || input.tagName == 'TEXTAREA')) {
							input.addEventListener('input', function () {
									checkReqs(e, reqFields, checkBoxes);
							});
					} else if (input.tagName == 'SELECT' || input.type == 'file') {
							input.addEventListener('change', function () {
									checkReqs(e, reqFields, checkBoxes);
							});
					}
			});
	}


});

function checkReqs(parent, reqFields, checkBoxes) {

	const allFilled = Array.from(reqFields).every(input => {
			return input.hasAttribute('required') ? (input.value.trim() !== '') : true;
	});

	if ( checkBoxes.length > 0 ) {
			const checkedItems = Array.from(checkBoxes).filter((checkbox) => checkbox.checked);
			
			if (allFilled && checkedItems.length > 0) {
					parent.classList.add('valid-fields');
			} else {
					parent.classList.remove('valid-fields');
			}
	} else {
			if (allFilled) {
					parent.classList.add('valid-fields');
			} else {
					parent.classList.remove('valid-fields');
			}
	}


	const accordions = document.querySelectorAll('form#create_customer .accordion');

	// Check if all accordions have the class 'valid-fields'
	const allValid = Array.from(accordions).every(accordion => {
			return accordion.classList.contains('valid-fields');
	});

	const registerFormTrigger = document.querySelector('#registerFormTrigger');

	console.log(allValid);

	// If all accordions have the class 'valid-fields', log the message
	if (allValid) {
			document.getElementById('registerButton').removeAttribute('disabled')
			if(registerFormTrigger) {
				registerFormTrigger.removeAttribute('disabled')
			}
	} else {
			document.getElementById('registerButton').setAttribute('disabled','')
			registerFormTrigger.setAttribute('disabled', '');
	}
}

document.querySelectorAll('.accordion').forEach((accordion) => {
  accordion.querySelector('summary').addEventListener('click', () => {
    const allOptional = Array.from(accordion.querySelectorAll('input')).every(input => {
      return !input.hasAttribute('required');
    });
    console.log(allOptional);
    if(allOptional) {
      accordion.classList.add('valid-fields');

      var reqFields = accordion.querySelectorAll('input[type="text"], input[type="password"], input[type="email"], select');
      var checkBoxes = accordion.querySelectorAll('[type="checkbox"]');
      checkReqs(accordion, reqFields, checkBoxes);
      
    }
  })
})